export const environment = {
  version: '1.38',
  production: true,
  apiUrl: '/api/',
  modeDebug: true,
  domain: 'localhost'
};
